<div class="menu-item me-lg-1">
  <a
    class="menu-link py-3"
    routerLinkActive="active menu-here"
    [routerLink]="menu.url"
  >
    @if (isShowIcon && menu.icon!.length) {
    <span class="menu-icon">
      <app-keenicon
        [name]="menu.icon!"
        class="fs-2 svg-icon svg-icon-2"
      ></app-keenicon>
    </span>
    }@else if(isShowIcon && !menu.icon!.length) {
    <span class="menu-bullet">
      <span class="bullet bullet-dot"></span>
    </span>
    }
    <span class="menu-title">{{ menu.title | translate }}</span>
  </a>
</div>
